"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarEventCardContent = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
var _utils2 = require("../utils");
var _lodash = require("lodash");
var _components = require("../../../components");
var _EventTextForCalendar;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventTextForCalendarGroup = (_EventTextForCalendar = {}, _defineProperty(_EventTextForCalendar, _utils2.CalendarGroup.MonumentAppointments, 'Monument Appointment'), _defineProperty(_EventTextForCalendar, _utils2.CalendarGroup.BlockingEvents, 'Busy'), _defineProperty(_EventTextForCalendar, _utils2.CalendarGroup.RecurringAvailability, 'Recurring Availability'), _defineProperty(_EventTextForCalendar, _utils2.CalendarGroup.DateBasedAvailability, 'Date-Specific Availability'), _EventTextForCalendar);
var CalendarEventCardContent = function CalendarEventCardContent(_ref) {
  var eventInfo = _ref.eventInfo,
    calendars = _ref.calendars,
    clinician = _ref.clinician,
    onExtendAppointment = _ref.onExtendAppointment;
  var _calendarEventToAppoi = (0, _utils2.calendarEventToAppointmentData)(eventInfo),
    patient = _calendarEventToAppoi.patient,
    extendedProps = _calendarEventToAppoi.extendedProps;
  var calendarsById = (0, _lodash.keyBy)(calendars, 'calendarId');
  var eventText = EventTextForCalendarGroup[extendedProps.calendarGroup];
  if (eventInfo.timeText) {
    var calendar = calendarsById[extendedProps.calendarId];
    var content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, eventInfo.timeText, " - ", eventText), patient && /*#__PURE__*/_react.default.createElement("p", null, (0, _utils.personName)(patient)), /*#__PURE__*/_react.default.createElement("p", {
      className: "opacity-80"
    }, (0, _utils2.getCalendarName)(calendar, clinician)));
    return /*#__PURE__*/_react.default.createElement(_components.Tooltip, {
      title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, content, extendedProps.extendBooking && /*#__PURE__*/_react.default.createElement("div", {
        className: "w-full flex justify-center"
      }, /*#__PURE__*/_react.default.createElement(_components.PrimaryButton, {
        size: "small",
        type: "emphasis",
        className: "mt-[8px]",
        onClick: onExtendAppointment
      }, "Change to 1hr"))),
      overlayClassName: "tw-body-sm-medium max-w-[310px]"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "pointer-events-auto"
    }, extendedProps.extendBooking && /*#__PURE__*/_react.default.createElement(_components.MonumentTag, {
      type: "alert"
    }, "Change to 1 hr"), content));
  } else {
    var textColor = extendedProps.calendarGroup === _utils2.CalendarGroup.DateBasedAvailability ? 'text-white' : 'text-black';
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "text-[0.85em] ".concat(textColor)
    }, eventText);
  }
};
exports.CalendarEventCardContent = CalendarEventCardContent;